"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var pages_1 = require("../../pages");
require("./warning-page.component.scss");
var WarningPageComponent = /** @class */ (function (_super) {
    __extends(WarningPageComponent, _super);
    function WarningPageComponent(cdRef) {
        var _this = _super.call(this) || this;
        _this.cdRef = cdRef;
        /**
         * To hide Ok button, if necessary.
         * @default
         * @type {boolean}
         * @since 3.1.0
         */
        _this.displayOkButton = true;
        /**
         * Message to interpret warning message.
         * @type {string}
         */
        _this.warningMessage = null;
        _this.userName = '';
        _this.buttonMessage = 'Ok';
        _this.fullScreen = true;
        _this.customOkFunction = new core_1.EventEmitter();
        return _this;
    }
    WarningPageComponent.prototype.onOkClicked = function () {
        this.fullScreen ? window.close() : this.customOkFunction.emit();
    };
    WarningPageComponent.prototype.ngAfterViewInit = function () {
        this.isSisWarningPageInitialized = true;
        this.cdRef.detectChanges();
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], WarningPageComponent.prototype, "displayOkButton", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], WarningPageComponent.prototype, "warningMessage", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], WarningPageComponent.prototype, "userName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], WarningPageComponent.prototype, "buttonMessage", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], WarningPageComponent.prototype, "fullScreen", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], WarningPageComponent.prototype, "customOkFunction", void 0);
    WarningPageComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'sis-warning-page',
            template: require('./warning-page.component.html'),
        }),
        __metadata("design:paramtypes", [core_1.ChangeDetectorRef])
    ], WarningPageComponent);
    return WarningPageComponent;
}(pages_1.PageComponent));
exports.WarningPageComponent = WarningPageComponent;
//# sourceMappingURL=warning-page.component.js.map